import { ActionTypes } from 'src/constants.js'

export const setGlobalTextSize = textSize => ({
  type: ActionTypes.SET_GLOBAL_TEXT_SIZE,
  payload: textSize,
})
